import { Variants } from '../types/variant';
import {
  isRiCardReportEligible,
  isRiPlainTextReportEligible,
} from '../util/riPlainTextReport';

export const radioInterventionnelleVariants = {
  radiologie_interventionnelle: {
    name: 'Radiologie interventionnelle',
    status: 'beta',
    availableInDemo: false,
    description:
      'Questionnaire pour les patients en radiologie interventionnelle. Couvre les motifs de consultation, les antécédents personnels et familiaux du patient ainsi que la prévention.',
    speciality: 'RADIO-INTERVENTIONNELLE',
    patientOnboarding: 'DEFAULT',
    patientOffboarding: 'DIRECT_CONFIRMATION',
    emailTemplate: 'MED_G_DEFAULT',
    // Report template by KB version (ALDO-2650):
    //  - newer than prod's 58.3 → the plain-text "letter" (dotted-segment
    //    compare, so 58.10 > 58.3 — see isRiPlainTextReportEligible).
    //  - 57.6 … 58.3 → the original card template. Kept so already-generated
    //    reports don't change shape retroactively; the type stays registered.
    //  - before 57.6 → QUESTIONS_ANSWERS: pre-57.5 reports have no report
    //    spans at all, and 57.5 isn't worth a separate structured path.
    reportTemplate: ({ version }) => {
      if (isRiPlainTextReportEligible(version)) {
        return 'INTERVENTIONAL_RADIOLOGY_PLAIN';
      }
      return isRiCardReportEligible(version)
        ? 'INTERVENTIONAL_RADIOLOGY'
        : 'QUESTIONS_ANSWERS';
    },
    initialQuestions: [],
    initialAssertions: [],
    pages: {
      CONSULTATION: {
        title: 'Consultation',
        sections: ['INTRODUCTION'],
      },
      COMPLAINTS: {
        title: 'Motifs',
        sections: [
          'MOTIF',
          'VARICOCELE',
          'FIBROME',
          'FIBROME_QOL',
          'HEMORROIDES',
          'VARICES_PELVIENNES',
          'VP_DOULEUR',
          'POSTOP_VARICOCELE',
          'POSTOP_FIBROME',
          'POSTOP_HEMORROIDES',
          'POSTOP_CONGESTION',
        ],
      },
      HISTORY: {
        title: 'Antécédents',
        sections: [
          'ANTÉCÉDENTS PERSONNELS',
          'ANTÉCÉDENTS FEMME',
          'ANTÉCÉDENTS FAMILIAUX',
        ],
      },
      PREVENTION: {
        title: 'Prévention',
        sections: ['ALIMENTATION', 'ACTIVITE_PHYSIQUE', 'TABAC', 'ALCOOL'],
      },
      CONCLUSION: {
        title: 'Conclusion',
        sections: ['RECAP'],
      },
    },
    options: [],
  },
} satisfies Variants;
